import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Registration } from '../../../hooks/api/utils/types';
import { selectCompanyRegistration } from '../../../redux/preferences/selectors';
import AdminSubHeader from '../../layouts/partials/AdminSubheader';
import RegistrationFrequentPassageRequests from '../../shared/frequentPassageRequests/RegistrationFrequentPassageRequests';

type Props = {
  registration: Registration;
};

function _FrequentPassageRequestsList({ registration }: Props) {
  return (
    <div>
      <AdminSubHeader title="Frequent Passages" key="subheader" breadcrumbs={[]} />
      <RegistrationFrequentPassageRequests registration={registration} admin={false} />
    </div>
  );
}

const mapStateToProps = (state: object) => ({
  registration: selectCompanyRegistration(state),
});

const FrequentPassageRequestsList = connect(mapStateToProps)(_FrequentPassageRequestsList);

export default FrequentPassageRequestsList;
